import styled from "styled-components/macro";

const breakpoints = {
  mobile: "screen and (max-width: 768px)",
  tablet: "screen and (max-width: 960px)",
  smallLaptop: "screen and (max-width: 1300px)",
  lg: "screen (max-width: 1530px)",
  xl: "screen and (min-width: 1531px)",
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f3f1e4;
  min-height: 100vh;

  .main {
    display: flex;
    max-width: 1400px;
    margin: 0 auto;
    gap: 40px;
    padding: 0 20px;
    margin-top: 20px;

    @media ${breakpoints.smallLaptop} {
      flex-direction: column;
      align-items: center;
    }

    .back-link {
      display: none;
    }
  }

  .left {
    flex-basis: 650px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    max-width: 800px;
    min-width: 650px;

    @media ${breakpoints.smallLaptop} {
      max-width: 700px;
      order: 2;
    }

    @media ${breakpoints.tablet} {
      min-width: unset;
    }
  }

  .right {
    flex-basis: 550px;
    flex-grow: 1;

    @media ${breakpoints.smallLaptop} {
      max-width: 700px;
      order: 1;
    }

    .logos-container {
      margin-left: 0;
      margin-right: 0;
      align-items: flex-start;
      width: 80%;

      @media ${breakpoints.smallLaptop} {
        width: unset;
      }

      .logos {
        margin-top: 10px;
        gap: 6px 20px;
      }
      .as-seen-in {
        display: none;
      }

      img {
        max-height: 40px;
        opacity: 0.25;
        margin-bottom: 0;
      }
    }
  }

  .sudowrite-explainer {
    border: 2px solid rgba(56, 56, 56, 0.1);
    border-radius: 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 80%;

    @media ${breakpoints.smallLaptop} {
      width: unset;
    }

    @media ${breakpoints.tablet} {
      margin-top: 120px;
    }

    .sudowrite-banner {
      flex-shrink: 0;
      // background: lightgray 50% / cover no-repeat;
    }
    .explainer-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 2em;
      text-align: left;
      position: relative;

      @media ${breakpoints.mobile} {
        padding-top: 160px;
      }

      .intro {
        font-size: 22px;
        margin-bottom: 20px;
      }
      p {
        color: #383838;
        text-shadow: 0px 0.843px 0.843px rgba(0, 0, 0, 0.1);
        font-family: GT Super Text;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 27px */

        img {
          float: right;
          max-width: 200px;
          transform: translateX(66%) scale(1.75);
          width: 12vw;
          margin-bottom: 20px;

          &.flipped {
            display: none;
            float: none;
            width: unset;
            margin-bottom: unset;
            margin: 0;

            max-width: 365px;
            width: calc(100vw - 25px);
            object-fit: contain;
            position: absolute;
            top: -120px;
            left: 50%;
            transform: translateX(-50%);
          }

          @media ${breakpoints.mobile} {
            display: none;

            &.flipped {
              display: block;
            }
          }
        }
      }
      button {
        width: 200px;
        height: 40px;
        background: #4908d1;
        border-radius: 8.7px;
        color: white;
        font-size: 1.2em;
        border: none;
        margin-top: 20px;
        cursor: pointer;
        font-weight: 500;
      }
    }
  }
  .footer-container {
    margin-top: 2em;
  }
`;
